import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-onget-side-bar',
  standalone: true,
  imports: [CommonModule, RouterModule, NgIcon],
  templateUrl: './onget-side-bar.html',
  styleUrl: './onget-side-bar.css',
})
export class OngetSideBar {
  @Input() item: any;
}
